import type { ReactNode } from 'react';
import { cn } from '@shared/utils/utils';

interface ProfileSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function ProfileSection({
  title,
  description,
  children,
  className,
  'data-testid': dataTestId,
}: ProfileSectionProps) {
  return (
    <section
      className={cn('overflow-hidden rounded-lg border border-border bg-background', className)}
      data-testid={dataTestId}
    >
      <div className="border-b border-border bg-background px-4 py-3">
        <h2 className="text-sm font-medium text-foreground">{title}</h2>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
      </div>
      <div className="px-4 py-4">{children}</div>
    </section>
  );
}
